import React from "react"

export const Home = () => {
    return (<React.Fragment><h1>how fast is this</h1></React.Fragment>)
}